import { render } from "./WaveDetailsPanel.vue?vue&type=template&id=afb0b55e&scoped=true"
import script from "./WaveDetailsPanel.vue?vue&type=script&lang=js"
export * from "./WaveDetailsPanel.vue?vue&type=script&lang=js"

import "./WaveDetailsPanel.vue?vue&type=style&index=0&id=afb0b55e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afb0b55e"]])

export default __exports__